import { wojOptions } from "./Offer";

export class Parcel {
  constructor(data) {
    // const {
    //   id,
    //   nr_ew_dzialek,
    //   nr_obre,
    //   gmina,
    //   powiat,
    //   pow_dzialki,
    //   geometria,
    //   wojewodztwo,
    //   __wlasciciele
    // } = data;
    for (const key in data) {
      this[key] = data[key];
    }
    delete this.pow_dzialki;
    delete this.geometria;
    delete this.__wlasciciele;
    this.powierzchnia = data.pow_dzialki;
    this.geometry = data.geometria;
    this.wlasciciele = data.__wlasciciele
    // this.id = id;
    // this.nr_ew_dzialek = nr_ew_dzialek;
    // this.nr_obre = nr_obre;
    // this.gmina = gmina;
    // this.powiat = powiat;
    // this.powierzchnia = pow_dzialki;
    // this.geometry = geometria;
    // this.wojewodztwo = wojewodztwo;
    // this.wlasciciele = __wlasciciele;
  }
}

function generateGeometry() {
  let x = (Math.random() * (2580391 - 1651561) + 1651561).toFixed(2);
  let y = (Math.random() * (7209537 - 6424431) + 6424431).toFixed(2);
  return {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [parseFloat(x), parseFloat(y)],
          [parseFloat(x), parseFloat(y - 10000)],
          [parseFloat(x - 10000), parseFloat(y - 10000)],
          [parseFloat(x - 10000), parseFloat(y)],
          [parseFloat(x), parseFloat(y)]
        ]
      ]
    }
  };
}

function generateRandomData() {
  let data = [];
  for (let idx of [...Array(30).keys()]) {
    data.push({
      id: idx + 1,
      number: `${idx + 1}`,
      precinct: `Obręb nr ${idx + 1}`,
      area: parseFloat((Math.random() * (100 - 10) + 10).toFixed(2)),
      geometry: generateGeometry(),
      woj: wojOptions[(Math.random() * 15).toFixed(0)].value
    });
  }
  return data;
}

export const TEST_DATA = generateRandomData();

export const TEST_HEADERS = [
  {
    text: "number",
    value: "number",
    type: "text"
  },
  {
    text: "precinct",
    value: "precinct",
    type: "text"
  },
  {
    text: "area",
    value: "area",
    type: "number"
  },
  {
    text: "tools",
    value: "tools",
    align: "center",
    sortable: false
  }
];
